module.exports = __webpack_public_path__ + "img/send-invites-desktop-en.8d761ab4.jpg";